export const messages = {
  en: {
    housekeepingFeeConfig: {
      title: 'Housekeeping Fee Config',
      queryConditions: 'Query Conditions',
      feeStandard: 'Fee Standard',
      feeName: 'Fee Name',
      feeType: 'Fee Type',
      computingFormula: 'Computing Formula',
      unitPrice: 'Unit Price',
      startTime: 'Start Time',
      endTime: 'End Time',
      isDefault: 'Is Default',
      operations: 'Operations',
      add: 'Add',
      edit: 'Edit',
      delete: 'Delete',
      confirmDelete: 'Confirm Delete',
      cancel: 'Cancel',
      save: 'Save',
      reset: 'Reset',
      back: 'Back',
      areaPrice: 'Area * Price',
      fixedFee: 'Fixed Fee',
      feeNegotiable: 'Fee Negotiable',
      yes: 'Yes',
      no: 'No',
      deleteConfirm: 'Are you sure to delete this fee standard?',
      requiredFeeName: 'Please input fee name',
      requiredFeeType: 'Please select fee type',
      requiredFormula: 'Please select computing formula',
      requiredPrice: 'Please input unit price',
      requiredStartTime: 'Please select start time',
      requiredEndTime: 'Please select end time',
      requiredIsDefault: 'Please select is default'
    }
  },
  zh: {
    housekeepingFeeConfig: {
      title: '家政费用标准管理',
      queryConditions: '查询条件',
      feeStandard: '费用标准',
      feeName: '费用名称',
      feeType: '费用类型',
      computingFormula: '计算公式',
      unitPrice: '单价',
      startTime: '开始时间',
      endTime: '结束时间',
      isDefault: '默认费用',
      operations: '操作',
      add: '添加',
      edit: '修改',
      delete: '删除',
      confirmDelete: '确认删除',
      cancel: '取消',
      save: '保存',
      reset: '重置',
      back: '返回',
      areaPrice: '面积*单价',
      fixedFee: '固定费用',
      feeNegotiable: '费用面议',
      yes: '是',
      no: '否',
      deleteConfirm: '确定删除费用标准？',
      requiredFeeName: '请输入费用名称',
      requiredFeeType: '请选择费用类型',
      requiredFormula: '请选择计算公式',
      requiredPrice: '请输入单价',
      requiredStartTime: '请选择开始时间',
      requiredEndTime: '请选择结束时间',
      requiredIsDefault: '请选择是否默认费用'
    }
  }
}